/* eslint-disable jsx-a11y/alt-text */
import LandingPageLayout from "../../components/landingPageLayout";
import { Col, Container, FormGroup, FormLabel, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { Form } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import map from "../../assets/images/map.png";
import contact from "../../assets/images/c1.png";
import msg from "../../assets/images/c2.png";
import address from "../../assets/images/c3.png";
import { useFormik } from "formik";
import logo from "../../assets/svg/logo.svg";
import { RotatingLines } from "react-loader-spinner";
import styles from "../contactus/contactUs.module.scss";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { inspectorForm } from "../../services/contact.services";
import "react-phone-input-2/lib/style.css";
import { HomeOwnerSchema, InspectorSchema } from "../../validations/validation";

const ContactUs = () => {
  const [loading, setLoading] = useState(false);
  const [num, setNum] = useState(0);
  const [code, setCode] = useState("");
  const [length, setLength] = useState(0);
  const [blur, setBlur] = useState(false);
  const [name, setName] = useState("");
  const initialValuesNew = {
    name: "",
    organizationOrIndividual: "",
    email: "",
    phone: "",
    organization_name: "",

    message: "",
  };

  const data: any = [
    { name: "Select", vale: 0 },
    { name: "Individual", vale: 2 },
    {
      name: "Organization",
      vale: 1,
    },
    {
      name: "Schedule inspection",
      vale: 3,
    },
  ];
  const formik = useFormik({
    initialValues: initialValuesNew,
    validationSchema: HomeOwnerSchema(name === "Organization", num, length),
    onSubmit: async (values: any) => {
      try {
        if (length > 1 && length < 11) {
        } else {
          setLoading(true);
          const response: any = await inspectorForm({
            ...values,
            type: "homeowner",
            organizationOrIndividual:
              values.organizationOrIndividual === "Individual"
                ? "individual"
                : values.organizationOrIndividual === "Organization"
                ? "organization"
                : "schedule inspection",
            organization_name:
              values.organization_name === ""
                ? undefined
                : values.organization_name,
            message: values?.message === "" ? undefined : values.message,
            phone:
              values.phone === "1" || values.phone === ""
                ? undefined
                : `+${code} ${values.phone.substring(num)}`,
          });

          if (
            response?.data?.status === 201 ||
            response?.data?.status === 200
          ) {
            toast.success(response?.data?.message);
            setBlur(false);
            setLength(0);
            // formik.setFieldError("phone", "");
            formik.setFieldValue("organizationOrIndividual", "");
            formik.resetForm();

            setLoading(false);
            formik.setFieldValue("phone", code);
          } else {
            toast.error("error");
            setLoading(false);
          }
          setLoading(false);
        }
      } catch (e: any) {
        toast.error("error");
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // useEffect(() => {
  //   if (length === 0 && blur) {
  //     formik.setFieldError("phone", "");
  //     setBlur(false);
  //   }
  // }, [length, blur]);

  return (
    <LandingPageLayout>
      <>
        <div className={styles.aboutUsWrapper}>
          <div className={styles.aboutUsContent}>
            <div className={styles.aboutUsHeader}>
              <h1>Contact Us</h1>
            </div>
          </div>
        </div>

        <Container>
          <div style={{ marginBottom: "80px" }}>
            <Row className="m-3 mb-5">
              <Col md={12} lg={6}>
                <div className={styles.secondSection}>
                  <h2>Get in touch with Us</h2>
                </div>
                <form
                  onSubmit={(e: any) => {
                    e.preventDefault();

                    formik.handleSubmit();
                  }}
                >
                  <div className={styles.input_contact}>
                    <Form.Group className={styles.input_}>
                      <Form.Label>
                        Name<span className={styles.asterisk}>*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter your name"
                        className="formall"
                        type="text"
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        isInvalid={!!formik.errors.name && formik.touched.name}
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className={styles.input_}>
                      <Form.Label>
                        Email<span className={styles.asterisk}>*</span>
                      </Form.Label>
                      <Form.Control
                        placeholder="Enter your email"
                        className="formall"
                        name="email"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        isInvalid={
                          !!formik.errors.email && formik.touched.email
                        }
                      ></Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.email}
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className={styles.input_}>
                      <Form.Label>Phone Number</Form.Label>
                      <PhoneInput
                        country={"us"}
                        onlyCountries={["us"]}
                        // onBlur={() => setBlur(!blur)}
                        value={formik.values.phone}
                        onChange={(value: any, data: any) => {
                          const currentCountryCode = formik.values.phone
                            ? formik.values.phone.substring(
                                0,
                                data.dialCode.length
                              )
                            : data.dialCode;

                          // Extract the phone number without the country code
                          const phoneNumber = value
                            ? value.substring(data.dialCode.length)
                            : "";

                          // Update the state with the new values
                          setCode(data.dialCode);
                          setLength(value.length);
                          setNum(data.dialCode.length);

                          // Concatenate the country code with the new phone number
                          const newPhoneNumber =
                            currentCountryCode + phoneNumber;

                          // Set the new value in the formik field
                          formik.setFieldValue("phone", newPhoneNumber);
                        }}
                        onKeyDown={(
                          event: React.KeyboardEvent<HTMLInputElement>
                        ) => {
                          const countryCode = formik.values.phone
                            ? formik.values.phone.substring(0, code.length)
                            : "";

                          // Allow editing the rest of the phone number, prevent deletion of country code
                          if (
                            event.key === "Backspace" &&
                            formik.values.phone === countryCode
                          ) {
                            event.preventDefault();
                          }
                        }}
                      />
                      {/* <Form.Control
                        type="number"
                        placeholder="Enter phone number"
                        name="phone"
                        onChange={formik.handleChange}
                        value={formik.values.phone}
                        isInvalid={
                          !!formik.errors.phone && formik.touched.phone
                        }
                      ></Form.Control> */}
                      {length > 1 && length < 11 && (
                        <span style={{ color: "#dc3545", fontSize: "14px" }}>
                          Please enter a 10-digit phone number.
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group className={styles.input_}>
                      <Form.Label>
                        Organization/individual
                        <span className={styles.asterisk}>*</span>
                      </Form.Label>
                      <Form.Select
                        className="formall"
                        value={formik.values.organizationOrIndividual}
                        onChange={(e: any) => {
                          setName(e.target.value);
                          formik.setFieldValue(
                            "organizationOrIndividual",
                            e.target.value
                          );
                        }}
                        isInvalid={
                          !!formik.errors.organizationOrIndividual &&
                          formik.touched.organizationOrIndividual
                        }
                      >
                        {data.map((item: any) => (
                          <option key={item.value}>{item.name}</option>
                        ))}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.organizationOrIndividual}
                      </Form.Control.Feedback>
                    </Form.Group>
                    {name === "Organization" && (
                      <Form.Group className={styles.input_}>
                        <Form.Label>
                          Name of Organization
                          <span className={styles.asterisk}>*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          className="formall"
                          name="organization_name"
                          value={formik.values.organization_name}
                          onChange={formik.handleChange}
                          placeholder="Enter your name"
                          isInvalid={
                            !!formik.errors.organization_name &&
                            formik.touched.organization_name
                          }
                        ></Form.Control>
                        <Form.Control.Feedback type="invalid">
                          {formik.errors.organization_name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    )}
                  </div>
                  <Form.Group className={styles.input_msg}>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="Message"
                      type="text"
                      name="message"
                      value={formik.values.message}
                      onChange={formik.handleChange}
                      isInvalid={
                        !!formik.errors.message && formik.touched.message
                      }
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {formik.errors.message}
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className={styles.btn}>
                    <button
                      type="submit"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Submit{" "}
                      {loading && (
                        <div>
                          {" "}
                          <RotatingLines
                            strokeColor="white"
                            strokeWidth="5"
                            animationDuration="0.75"
                            width="18"
                            visible={true}
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </form>
              </Col>
              <Col md={12} lg={6}>
                <div className={styles.image}>
                  <img src={map} />
                </div>
                <div className={styles.contact_add}>
                  {/* <div className={styles.logo}>
                    <img src={logo} />
                  </div>
                  <div className={styles.head}>
                    <span>
                      We appreciate your interest.
                      <br /> Please contact us from the <br /> options below.
                    </span>
                  </div> */}
                  <div className={styles.conatct_card}>
                    <div className={styles.card}>
                      {" "}
                      <p>Phone Number</p>
                      <span>
                        {" "}
                        <a
                          style={{ textDecoration: "none", color: "black" }}
                          href="tel:+19734494171"
                        >
                          {" "}
                          973-449-4171
                        </a>
                      </span>
                      <img src={contact} />
                    </div>
                    <div className={styles.card}>
                      {" "}
                      <p>Email Address</p>
                      <span className={styles.new_ad}>
                        <a href="mailto: sales@constructioncodeinspections.com">
                          {" "}
                          sales@constructioncodeinspections.com
                        </a>
                      </span>
                      <img src={msg} />
                    </div>
                    <div className={styles.card}>
                      <p>Address</p>
                      <span>460 Bloomfield Avenue, Montclair NJ 07006</span>
                      <img src={address} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </>
    </LandingPageLayout>
  );
};

export default ContactUs;
